import {useState, useEffect, useRef } from "react";

import {ajaxAction} from "../functions/ajaxAction";


const ArticlesList = (props) => {
  console.log('props', props);


  const [pageState, pageAction] = useState({
    posts:false,
    loading:false,
    categories:props.args.categories,
    tags:props.args.tags,
    search:'', // this is display value in the search input, it is not immediately in the queryState (does not trigger articles load) till typing timeout
    featured:props.args.featured,
    featuredPost:false,
    showFilters:false,
    totalPages:0,
    currentPage:1, // first page is 1 in WordPress
    listType:props.args.listType,
    articleType:props.args.articleType,
    showSearch:props.args.search
  });

  /*
     User action (clicks, typing, browser navigation) will update the queryState
     Updates to queryState will trigger useEffects to load articles
     When articles are loaded, the pageState is updated with the new articles, featured post and pagination details, which will trigger a re-render
     Note to self: queryState should be updated only by user actions
   */
  const [queryState, queryAction] = useState({
    category: [], // slugs of active categories
    tag:[], // slugs of active tags
    search:'', // this is the actual search query, it is updated after a timeout when user stops typing
    page:1
  });

  // keep track of when the monitored component parts are rendered for the first time so we can skip the first useEffect
  const isRendered = useRef({ page:false, search : false });

  // keep track if query state is updated by browser navigation and avoid updating url history if query state is updated by popstate
  const preventUrlUpdate = useRef(false);

  // on paging we go to the top of the page
  const paging = useRef(false);


  // load articles from the server
  // args is an object with properties to override the default queryState values or pass additional data
  // loadArticles is called when queryState changes, and it doesn't modify queryState itself
  function loadArticles(args) {
    pageAction({...pageState, loading:true});

    let postData = {
      category: queryState.category.join(','),
      tag:      queryState.tag.join(','),
      search:   queryState.search,
      page:     queryState.page
    };

    // if args is provided, override the values in postData
    if (args) {
      postData = {...postData, ...args};
    }

    // console.log('preventUrlUpdate', preventUrlUpdate.current);
    // update the url with the new query state
    if (!preventUrlUpdate.current) {
      let urlParams = new URLSearchParams();
      if (postData.category) {
        urlParams.set('category', postData.category);
      }
      if (postData.tag) {
        urlParams.set('tag', postData.tag);
      }
      if (postData.search) {
        urlParams.set('search', postData.search);
      }
      if (postData.page) {
        urlParams.set('go', postData.page);
      }

      history.pushState({filters: JSON.stringify(queryState)}, '', urlParams.toString() ? `?${urlParams.toString()}` : window.location.pathname);
    } else {
      preventUrlUpdate.current = false; // reset the flag
    }

    ajaxAction('site/get-posts', (response) => {
      if (response.data) {
        pageAction({...pageState, posts:response.data.posts, featuredPost:response.data.featured, totalPages:response.data.totalPages , loading:false});
      } else {
        pageAction({...pageState, posts:false, loading:false});
      }

      // scroll to top of the .block-articles-list if we are paging
      if (paging.current) {
        jQuery('body, html').animate({scrollTop: jQuery('.block-articles-list').offset().top - 20}, 500);
        paging.current = false;
      }
    }, null, {...postData, featured: pageState.featured, listType: pageState.listType, articleType: pageState.articleType});
  }

  /**
   * Toggle a filter. Adds or removes a filter slug from the queryState.category or queryState.tag arrays
   * If the filter is already active, it will be removed
   * Every time a filter is toggled, we go to page 1
   * @param slug string slug of a filter (category or tag)
   * @param type string 'category' or 'tag' to determine which array to update
   */
  function toggleFilter(slug, type) {
    let activeFilters = [...queryState[type]];

    // if empty slug, clear all filters
    if (slug === '') {
      activeFilters = [];
      queryAction({...queryState, [type]:activeFilters, page: 1});
      return;
    }

    let index = activeFilters.indexOf(slug);

    if (index === -1) {
      activeFilters.push(slug);
    } else {
      activeFilters.splice(index, 1);
    }

    queryAction({...queryState, [type]:activeFilters, page: 1});
  }

  function toggleCategory(slug) {
    toggleFilter(slug, 'category');
  }

  function toggleTag(slug) {
    toggleFilter(slug, 'tag');
  }

  function isFilterActive (slug, type) {
    return queryState[type].indexOf(slug) !== -1;
  }

  function toggleFilters() {
    pageAction({...pageState, showFilters:!pageState.showFilters});
  }

  function updateSearch(e) {
    pageAction({...pageState, search:e.target.value});
  }

  useEffect(() => {
    // on mount get the filters from the url
    const urlParams = new URLSearchParams(window.location.search);
    const filters = {};

    // parse the query string and get the filters
    // query string is in the format ?category=term1,term2,term3&tag=term1,term2,term3&search=term&go=1
    Array.from(urlParams.entries()).forEach(([key, value]) => {
      switch (key) {
        case 'category':
        case 'tag':
          filters[key] = value.split(',');
          break;
        case 'search':
          filters[key] = value;
          break;
        case 'go': // check if there is a page number and set it if not a number set to 1
          filters['page'] = isNaN(value) ? 1 : parseInt(value);
          break;
      }
    } );

    // since we are query state from the url, we don't want to update the url
    preventUrlUpdate.current = true; // this will prevent the url update by loadArticles

    // add popstate event listener to update the query state when the user navigates back or forward
    window.addEventListener("popstate", (event) => {
      if (event.state && event.state.filters) {
        // prevent updating the url when the query state is updated by popstate
        preventUrlUpdate.current = true;

        // parse filters json string (we passed the filters as json string in loadArticles)
        queryAction({...queryState, ...JSON.parse(event.state.filters)});
      }
    } );

    // finally update the query state with the filters from the url
    queryAction({...queryState, ...filters}); // this will trigger another useEffect to load articles

    // if there are filters enabled in the url, show the filters
    if (Object.keys(filters).length > 0) {
      pageAction({...pageState, showFilters:true});
    }

    // console.log('filters', filters);

  } , []);

  function gotoPage(page) {
    paging.current = true;
    queryAction({...queryState, page: page});
  }

  function toggleFaqItem(column, category, index) {
    let newColumn = {...column};

    let newState = !newColumn[category].posts[index].open;

    // close all other items in the category
    newColumn[category].posts = newColumn[category].posts.map((post) => {
      return {...post, open:false};
    } );

    newColumn[category].posts[index].open = newState;

    pageAction({...pageState, posts:pageState.posts.map((col) => {
      if (col === column) {
        return newColumn;
      } else {
        return col;
      }
    })});
  }

  useEffect(() => {
    // console.log('pageState', pageState);
  });

  // when query state changes reload articles
  // send categories and tags as comma separated string of slugs
  useEffect(() => {
    // skip the first render, we will chanqe the query state on mount to get the filters from the url if any
    if (!isRendered.current['page']) {
      isRendered.current['page'] = true;
      return;
    }

    // console.log('queryState', queryState);
    loadArticles();
  }, [queryState]);


  // after search changes wait for 500ms before sending request, clear timeout if search changes again while waiting
  useEffect(() => {
    if (!isRendered.current['search']) {
      isRendered.current['search'] = true;
      return;
    }

    const timeout = setTimeout(() => {
      queryAction({...queryState, search:pageState.search, page: 1}); // update search query after timeout and go to page 1
    }, 500);

    return () => clearTimeout(timeout );


  } , [pageState.search]);

  return (
    <div className={'type-' + pageState.listType}>
      {pageState.showSearch &&
        <div className={'filter-bar'}>
          <div className={'filters-wrapper'}>
            <div className={'filters-toggle'} onClick={toggleFilters}>
              <span className={'filter-label'}>Filter</span>
            </div>
            <div className={'search'}>
              <input type={'text'} placeholder={'Search'} value={pageState.search} onChange={updateSearch}/>
            </div>
          </div>
          {pageState.showFilters &&
            <div className={'filters'}>
              {pageState.categories && pageState.categories.length > 0 &&
                <div className={'categories filters-row'}>
                  <div className={'label'}>
                    Content type
                  </div>
                  {pageState.categories.map((category, index) => {
                    return (
                      <button key={index} value={category.slug} onClick={() => toggleCategory(category.slug)}
                              className={(isFilterActive(category.slug, 'category') ? 'active' : '')}>{category.name}</button>
                    );
                  })}
                </div>
              }

              {pageState.tags && pageState.tags.length > 0 &&
                <div className={'tags  filters-row'}>
                  <div className={'label'}>
                    Subject
                  </div>
                  {pageState.tags.map((tag, index) => {
                    return (
                      <button key={index} value={tag.slug} onClick={() => toggleTag(tag.slug)}
                              className={(isFilterActive(tag.slug, 'tag') ? 'active' : '')}>{tag.name}</button>
                    );
                  })}
                </div>
              }
            </div>
          }
        </div>
      }


      {pageState.loading &&
        <div className={'loader'}>
          <div className={'spinner'}></div>
        </div>
      }

      {/*
        Post Thumbs List variant
      */}

      {pageState.listType !== 'faq' &&
        <>
          <div className={"post-thumbs type-" + pageState.listType + (pageState.loading ? ' loading' : '')}>
            {pageState.featuredPost &&
              <div className="featured-post">
                <div className="content">
                  <div className="sub-head">
                    <div className="category">
                      {pageState.featuredPost.category}
                    </div>
                  </div>
                  <h3> {pageState.featuredPost.title} </h3>
                  <div className={'excerpt'}>
                    {pageState.featuredPost.excerpt}
                  </div>

                  <div className="wp-block-buttons is-layout-flex wp-block-buttons-is-layout-flex">
                    <div className="wp-block-button"><a href={pageState.featuredPost.permalink}
                                                        className="wp-block-button__link has-blue-background-color has-background wp-element-button"
                                                        style={{"--hover-color": "rgb(208, 235, 238)"}}>Read more</a></div>
                  </div>
                </div>
                <div className="image">
                  {pageState.featuredPost.image &&
                    <img src={pageState.featuredPost.image} alt={pageState.featuredPost.title}/>}
                </div>
              </div>
            }
            <div className="block-container">
              {(pageState.posts && pageState.posts.length > 0) ? pageState.posts.map((post, index) => {
                return (
                  <div className="post" key={index}>
                    <a href={post.permalink}>
                      <div className="image">
                        {post.image && <img src={post.image} alt={post.title}/>}
                      </div>
                      <div className="content">
                        <div className="sub-head">
                          <div className="post-date">
                            <span>{post.date}</span>
                          </div>
                          <div className="time-to-read">
                            {post.ttr} min read
                          </div>
                        </div>

                        <h3> {post.title} </h3>

                        <div className="category">
                          {post.category}
                        </div>
                      </div>
                    </a>
                  </div>
                );
              }) : ((!pageState.loading) && <div className="no-posts">No resources found</div>)}

              {/*  If number of posts is odd draw empty pos container */}
              {pageState.posts && pageState.posts.length % 2 !== 0 && <div className="post empty"></div>}

            </div>
          </div>

          {/*
            Pagination
          */}
          {pageState.posts && pageState.posts.length > 0 && pageState.totalPages > 1 &&
            <div className="pagination">
              <div className="page-numbers">
                <button disabled={queryState.page <= 1} onClick={() => gotoPage(queryState.page - 1)}>Previous</button>

                {Array.from(Array(pageState.totalPages).keys()).map((page, index) => {
                  const thePage = page + 1;
                  return (
                    <button key={index} onClick={() => gotoPage(thePage)}
                            className={(thePage === queryState.page ? 'active' : '')}>{thePage}</button>
                  );
                })}

                <button disabled={queryState.page >= pageState.totalPages} onClick={() => gotoPage(queryState.page + 1)}>Next</button>

              </div>
            </div>
          } {/* end Pagination */}
        </>
      } {/* end Post Thumbs List variant */}

      {/*
        FAQ variant
      */}
      {pageState.listType === 'faq' &&
        <div className={"faq-list" + (pageState.loading ? ' loading' : '')}>
          <div className="block-container">
            {/* In FAQ mode posts are split into columns, each column is object where each property is a category that has array posts in them */}
            {pageState.posts && pageState.posts.length > 0 && pageState.posts.map((column, index) => {
              return (
                <div className="column" key={index}>
                  {Object.keys(column).map((category, index) => {
                    return (
                      <div className="category" key={index} style={{"--category-color" : column[category].color}}>
                        <h3>{category}</h3>
                        {column[category].posts.map((post, index) => {
                          return (
                            <div className={"post" + (post.open ? ' open':'')} key={index}>
                              <div className="question" onClick={() => {
                                toggleFaqItem(column, category, index);
                              }}>
                                <span>{post.title}</span>
                                <svg width="28" height="23" viewBox="0 0 28 23" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                  <path d="M14 23L0.576609 0.499997L27.4234 0.5L14 23Z" fill={column[category].color}/>
                                </svg>
                              </div>
                              <div className="answer">
                                <div dangerouslySetInnerHTML={{__html: post.excerpt}}></div>
                                {post.showReadMore &&
                                  <a href={post.permalink}>Read more</a>
                                }

                              </div>
                            </div>
                          );
                        })}
                      </div>
                    );
                  })}
                </div>
              );

            })}
          </div>
        </div>
      } {/* end FAQ variant */}


    </div>

  );
}

export {ArticlesList}
